import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-24 bg-white" data-id="element-115">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-116">
        <FadeIn data-id="element-117">
          <div className="bg-brand-cream rounded-3xl p-8 md:p-16 text-center border border-brand-gold/20 shadow-lg" data-id="element-118">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-teal mb-6 font-serif" data-id="element-119">
              Recupera el control de tus finanzas hoy mismo.
            </h2>

            <p className="text-lg md:text-xl text-brand-charcoal/80 mb-10 max-w-2xl mx-auto" data-id="element-120">
              Por menos de lo que cuesta un recargo bancario típico, puedes
              detener el "Impuesto TDAH" de por vida.
            </p>

            <div className="mb-10" data-id="element-121">
              <span className="text-sm font-bold tracking-widest text-brand-gray uppercase mb-2 block" data-id="element-122">
                Inversión única
              </span>
              <div className="text-3xl text-brand-gray/60 font-serif line-through mb-1" data-id="element-123">
                $29 USD
              </div>
              <div className="text-6xl md:text-7xl font-bold text-brand-teal font-serif" data-id="element-124">
                $6.39{' '}
                <span className="text-2xl text-brand-gray font-sans" data-id="element-125">USD</span>
              </div>
              <span className="inline-block mt-3 px-4 py-1 bg-brand-gold/15 text-brand-gold text-sm font-semibold rounded-full tracking-wide uppercase" data-id="element-126">
                78% de descuento
              </span>
            </div>

            <Button href="https://cuidodemisalud.com/cart/47536263299259:1" className="w-full md:w-auto text-lg px-10 py-5 mb-6" data-id="element-127">
              Quiero Detener El Impuesto TDAH Ahora
            </Button>

            <div className="flex items-center justify-center text-sm text-brand-gray space-x-2" data-id="element-128">
              <ShieldIcon className="w-4 h-4" data-id="element-129" />
              <span data-id="element-130">
                Acceso inmediato después de la compra. Pago seguro y 100%
                privado.
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}